import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import ButtonsActions from "views/utils/buttonsActions";
import TopBarActions from "components/TopBarActions";
import PrevWaypoints from "./waypoints/PrevWaypoints";
import TableWaypoints from "./waypoints/TableWaypoints";
import FormWaypoints from "./waypoints/FormWaypoints";
import {WaypointModel} from "site-apps/distribution/waypoints/WaypointModels";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import {useNavigate} from "react-router-dom";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";

const ViewWaypoints = () => {
    const navigate = useNavigate();
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");
    const title = _Tr("labels.waypoints");
    document.title = title;
    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });

    const bread = [
        {name: _Tr("labels.route-management"), url: "/route-management", current: false},
        {name: title, current: true},
    ];
    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({...WaypointModel});
    const [showPrev, setShowPrev] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [itemsShown, setItemsShown] = useState([]);
    const [checkAll, setCheckAll] = useState(false);

    const headersTable = [
        {name: _Tt("common.icon"), attr: 0, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.name"), attr: 1, direction: "asc", active: true, default: true},
        {name: _Tt("common.type"), attr: 2, direction: "asc", active: false},
        {name: _Tt("containers.latitude"), attr: 3, direction: "asc", active: false},
        {name: _Tt("containers.longitude"), attr: 4, direction: "asc", active: false},
        {name: _Tt("common.time"), attr: 5, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = title;
        buttons.add.active = true;
        buttons.add.onClick = clickAdd;
        buttons.add.disabled = false;
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = clickEdit;
        buttons.delete.active = true;
        buttons.delete.onClick = clickDelete;
        buttons.delete.disabled = true;
        setButtonsTB({...buttons});
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchWaypoints();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchWaypoints();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = WaypointModel;
        fetchGetWaypoints();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        fetchWaypoints();
    };

    const fetchGetWaypoints = () => {
        setIsLoading(true);
        axiApi
            .get("/api/distribution/waypoints/")
            .then((resp) => {
                items.current.all = [...resp.data.items];
                items.current.showed = [...resp.data.items];
                items.current.checkBoxes = [];
                setItemsShown([...resp.data.items]);
                if (resp.data && resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchWaypoints = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/waypoints/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                if (resp.data && resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const clickAdd = () => {
        setItem({...WaypointModel});
        setShowForm(true);
    };

    const clickEdit = () => {
        const buttons = {...buttonsTB};
        if (items.current.chosen.length !== 1) {
            buttons.edit.disabled = true;
            setButtonsTB(buttons);
            return false;
        }
        let itemSelected = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        setItem({...itemSelected});
        setShowForm(true);
    };

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });

    const clickDelete = () => {
        AlertQuestion.warning("Borrar", `Se borrarán los ${items.current.chosen.length} seleccionados`).then((resp) => {
            if (resp.isConfirmed) {
                let ids = items.current.getChosenIds(); // Extraer IDs de los seleccionados
                setIsLoading(true);
                // axiApi.delete(`/api/distribution/waypoints/`, { data: { ids } }) // Realizar la petición DELETE
                axiApi
                    .delete(`/api/distribution/waypoints/`, {data: {ids}}) // Realizar la petición DELETE
                    .then((r) => {
                        // Filtrar los elementos eliminados correctamente
                        items.current.showed = items.current.showed.filter((item) => !r.data.ids.includes(item.id));
                        setItemsShown([...items.current.showed]);

                        // Limpiar los checkboxes seleccionados
                        items.current.checkBoxes.forEach((checkbox) => {
                            if (checkbox) checkbox.checked = false;
                        });

                        // Si el elemento eliminado era el que estaba en previsualización, actualizar
                        if (!items.current.chosen.includes(item.id)) {
                            setShowPrev(false);
                            setItem({...WaypointModel}); // Resetear el modelo de Waypoint
                        }
                        // Limpiar la selección
                        items.current.clearChosen();

                        if (r.data.ids_not_delete.length) {
                            let names = r.data.ids_not_delete.map(
                                (id) => items.current.showed.find((item) => item.id === id).name
                            );
                            Alert.warning("No se eliminaron", `Los elementos: ${names.join(", ")} no pudieron ser eliminados`);
                        }
                    })
                    .catch((error) => {
                        console.error("Error al enviar la solicitud:", error);
                        if (error.response && error.response.status === 403) {
                            navigate("/");
                        }
                    })
                    .finally(() => {
                        const buttons = {...buttonsTB};
                        // Actualizar botones
                        buttons.edit.disabled = true;
                        buttons.delete.disabled = true;
                        setButtonsTB({...buttons});
                        setIsLoading(false);
                    });
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableWaypoints
                            itemsShow={itemsShown}
                            setItemsShow={setItemsShown}
                            items={items}
                            checkAll={checkAll}
                            setCheckAll={setCheckAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                {showPrev ? (
                    <div className="col-md col-12 prev-item" style={{maxWidth: "300px"}}>
                        <PrevWaypoints item={item} showPreview={showPrev} _Tt={_Tt} />
                    </div>
                ) : (
                    <> </>
                )}
            </div>

            <FormWaypoints
                showForm={showForm}
                setShowForm={setShowForm}
                item={item}
                items={items}
                setItemsShown={setItemsShown}
            />
        </>
    );
};

export default ViewWaypoints;
